import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { getKeyForEvent } from "./__internal__/PerformanceEvent";
function getLatestMark(event) {
    var _getWindow, _performance_getEntriesByName_slice_, _performance_getEntriesByName_slice, _performance_getEntriesByName;
    var performance = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.performance;
    if (!performance) {
        return undefined;
    }
    var key = getKeyForEvent(event);
    return (_performance_getEntriesByName = performance.getEntriesByName) === null || _performance_getEntriesByName === void 0 ? void 0 : (_performance_getEntriesByName_slice = _performance_getEntriesByName.call(performance, key).slice(-1)) === null || _performance_getEntriesByName_slice === void 0 ? void 0 : (_performance_getEntriesByName_slice_ = _performance_getEntriesByName_slice[0]) === null || _performance_getEntriesByName_slice_ === void 0 ? void 0 : _performance_getEntriesByName_slice_.startTime;
}
export function getGlobalPerformanceMarks() {
    return {
        htmlStarted: getLatestMark({
            name: "htmlStarted"
        }),
        mainJsExecuted: getLatestMark({
            name: "mainJsExecuted"
        })
    };
}
